import api from "./apiSlice";

const paymentsApi = api.injectEndpoints({
  endpoints(build) {
    return {
      listPrices: build.query({
        query() {
          return "/extras/api/v1/payments/prices";
        },
        providesTags: ["PaymentPrice"],
        transformResponse(baseQueryReturnValue) {
          let lowestPrice = 99999999999;
          let highestPrice = 0;
          baseQueryReturnValue.forEach((priceData) => {
            if (priceData.recurring === false) {
              const currentPrice = Number(priceData.price);
              if (lowestPrice > currentPrice) {
                lowestPrice = currentPrice;
              }
              if (highestPrice < currentPrice) {
                highestPrice = currentPrice;
              }
            }
          });
          return { lowestPrice, highestPrice, prices: baseQueryReturnValue.filter((priceData) => priceData.recurring === false) };
        },
      }),
      getCreditsAvailable: build.query({
        query() {
          return "/extras/api/v2/usage/available";
        },
        providesTags: ["CreditsAvailable"],
        transformResponse(baseQueryReturnValue) {
          const available = baseQueryReturnValue.available_credits || 0;
          return { qualCredits: available.qual_credits_remaining, certCredits: available.cert_credits_remaining };
        },
      }),
    };
  },
});

export const { useListPricesQuery, useGetCreditsAvailableQuery } = paymentsApi;
